import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Install Seedance browser-session telemetry before App imports Production
// Control. Axios executes request interceptors newest-first: Control therefore
// gets first chance to suppress legacy Variant copies or rewrite a real 2.5
// spend to /sd25-control/execute; telemetry runs after that and counts only the
// request that will actually leave the browser.
import "@/lib/shotScopeBus";
import axios from "axios";
import App from "@/App";
import { I18nProvider } from "@/i18n/I18nContext";
import { installUploadTracking, hasUploadsInFlight } from "@/lib/uploadsInFlight";
import { installUnloadGuard, hasUnsavedWork, confirmLeave } from "@/lib/unsavedWork";
import { installPopstateGuard } from "@/lib/navigationGuard";
import { claimTabIdentity } from "@/lib/editorDraft";
import { registerServiceWorker, startTabPresence } from "@/lib/swUpdate";

// Cuenta toda subida en vuelo (cuerpo FormData) ANTES de que se monte nada: si
// se instalara más tarde, la primera subida de la sesión viajaría sin guard.
installUploadTracking(axios);

// Cerrar o recargar la pestaña también mata la subida y tira lo que el editor
// tiene sin enviar; ningún guard de recarga lo cubre. El navegador enseña su
// propio diálogo (no se puede personalizar). `installUnloadGuard` mira el
// registro de trabajo sin enviar (el editor se registra ahí) y las subidas.
installUnloadGuard(window, hasUploadsInFlight);
// Atrás/adelante del navegador con trabajo sin enviar: tiene que registrarse
// ANTES de que el Router monte su propio listener de popstate (ver
// lib/navigationGuard.js). Los enlaces y navigate() los cubre <NavigationGuard/>.
installPopstateGuard(window, () => confirmLeave("salir"));

// La pestaña reclama su identidad ANTES de montar: el editor lee su borrador con
// ella, y una pestaña duplicada (que hereda una copia de sessionStorage) tiene
// que acuñar un id propio en vez de adoptar el borrador de la original.
claimTabIdentity().catch(() => null).then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <I18nProvider>
        <App />
      </I18nProvider>
    </React.StrictMode>,
  );
});

// Censo de pestañas para el banner de actualización: cada pestaña con este
// código contesta si tiene trabajo sin enviar. Las que no contestan son de una
// versión anterior (que SÍ se recarga sola al cambiar el controlador).
startTabPresence({ getDirty: hasUnsavedWork });

// PWA (MB4 + SW1/SW2/SW4): registra el service worker. Solo App-shell; nunca
// cachea /api. Solo en producción — en dev estorbaría al hot-reload de CRA.
//
// Una actualización NUNCA recarga la pestaña sola: el SW nuevo queda en espera,
// `registerServiceWorker` lo anuncia (`orca-sw-update`) y el `UpdateBanner` deja
// que el usuario decida cuándo, esperando sin techo a cualquier subida. Un
// cambio de controlador provocado por OTRA pestaña solo muestra un aviso. Ver
// lib/swUpdate.js y public/sw.js.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  registerServiceWorker();
}
